import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { MermaidNodeView } from "./MermaidNodeView";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    mermaid: {
      setMermaid: (code?: string) => ReturnType;
    };
  }
}

export const MermaidExtension = Node.create({
  name: "mermaid",
  group: "block",
  atom: true,
  draggable: true,

  addAttributes() {
    return {
      code: {
        default: `flowchart TD
    A[Inicio] --> B{Decision}
    B -->|Si| C[Resultado 1]
    B -->|No| D[Resultado 2]`,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'pre[data-type="mermaid"]',
        getAttrs: (node) => {
          if (typeof node === "string") return {};
          const element = node as HTMLElement;
          return {
            code: element.textContent || "",
          };
        },
      },
      {
        tag: "pre:has(code.language-mermaid)",
        getAttrs: (node) => {
          if (typeof node === "string") return {};
          const element = node as HTMLElement;
          const codeEl = element.querySelector("code");
          return {
            code: codeEl?.textContent || "",
          };
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "pre",
      mergeAttributes({ "data-type": "mermaid" }, HTMLAttributes),
      ["code", { class: "language-mermaid" }, HTMLAttributes.code || ""],
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(MermaidNodeView);
  },

  addCommands() {
    return {
      setMermaid:
        (code?: string) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: {
              code:
                code ||
                `flowchart TD
    A[Inicio] --> B{Decision}
    B -->|Si| C[Resultado 1]
    B -->|No| D[Resultado 2]`,
            },
          });
        },
    };
  },
});
